import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

/**
 * Guard that ensures only member portal users (Member Admin or Member User)
 * can access /portal/* routes.
 * - Not authenticated → /launcher
 * - Authenticated but no member role → / (staff shell)
 */
export const portalAccessGuard: CanActivateFn = async (_route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // Wait for role sync to complete
  await authService.initReady();

  const user = authService.currentUser();

  if (!user) {
    return router.createUrlTree(['/launcher'], {
      queryParams: { returnUrl: state.url }
    });
  }

  // Check if user has a member portal role
  const isMemberPortalUser = user.orgRoleAssignments?.some(
    assignment =>
      assignment.roleNames?.includes('Member Admin') ||
      assignment.roleNames?.includes('Member User')
  );

  if (!isMemberPortalUser) {
    // Staff user trying to access portal — redirect to main app
    router.navigate(['/']);
    return false;
  }

  return true;
};
